import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/tips/icon_success.svg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-46158fae"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "tip-section"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "success-img",
    src: _imports_0
  }, null, -1);
});

var _hoisted_3 = {
  "class": "message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "fade",
    onAfterEnter: _ctx.afterShow
  }, {
    "default": _withCtx(function () {
      return [_ctx.show ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "success-tip mod-mask",
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.hide && _ctx.hide.apply(_ctx, arguments);
        })
      }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1)])])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["onAfterEnter"]);
}